if (!window._genesys) window._genesys = {};
(function () {
  // NOTE: Sharing sessionStorage content with other TEN platform tabs

  // GET_STORAGE_KEY: triggers request of storage object from other tabs
  var GET_STORAGE_KEY = 'getSessionStorage';
  // STORAGE_KEY: key received storage object from other tab
  var STORAGE_KEY = 'sessionStorage';

  if (!sessionStorage.length) {
    localStorage.setItem(GET_STORAGE_KEY, new Date().valueOf().toString());
    localStorage.removeItem(GET_STORAGE_KEY);
  }

  window.addEventListener('storage', function (event) {
    if (event.key === GET_STORAGE_KEY) {

      localStorage.setItem(STORAGE_KEY, JSON.stringify(sessionStorage));
      localStorage.removeItem(STORAGE_KEY);
    } else if (event.key === STORAGE_KEY) {
      var data = JSON.parse(event.newValue);

      for (var key in data) {
        sessionStorage.setItem(key, data[key]);
      }
    }

  });
})();